var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivitiesWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insights_black_24dp",
    transform: "translate(-0.381 0.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(0.381 0.312)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 14,
    height: 14,
    transform: "translate(0 -0.47)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0.844 0.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M12.851,8a1.215,1.215,0,0,0-1.144,1.53L9.6,11.7a1.174,1.174,0,0,0-.616,0L7.476,10.146a1.194,1.194,0,1,0-2.287,0l-2.7,2.774A1.194,1.194,0,0,0,1,14.1a1.206,1.206,0,0,0,1.185,1.219,1.215,1.215,0,0,0,1.144-1.53l2.7-2.78a1.174,1.174,0,0,0,.616,0L8.152,12.56a1.194,1.194,0,1,0,2.287,0L12.548,10.4a1.194,1.194,0,0,0,1.487-1.177A1.206,1.206,0,0,0,12.851,8Z",
    transform: "translate(-1 -4.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M14.393,7.787l.75-1.651,1.643-.742-1.643-.742L14.393,3l-.734,1.651L12,5.393l1.659.742Z",
    transform: "translate(-6.329 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M2.994,9.989l.4-1.6,1.6-.4-1.6-.4L2.994,6,2.6,7.6l-1.6.4,1.6.4Z",
    transform: "translate(-1 -4.171)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesWhite);
export default __webpack_public_path__ + "static/media/activities_white.bbe2029dec46e5991e72d26ba0beb3d1.svg";
export { ForwardRef as ReactComponent };